import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { Box, CircularProgress, Link, Typography } from '@material-ui/core'

const NOVO_SISTEMA_URL = 'https://quiero.q2f.com.br'

// Tela migrada para o web novo: troca a URL (replace) para o "voltar" não cair aqui de novo.
const RedirectNovoSistema = ({ to }) => {
  const url = NOVO_SISTEMA_URL + to

  useEffect(() => {
    window.location.replace(url)
  }, [url])

  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      minHeight="100vh"
      textAlign="center"
      p={2}
    >
      <CircularProgress />
      <Box mt={3} mb={1}>
        <Typography variant="h4">Esta tela agora está no novo sistema</Typography>
      </Box>
      <Typography color="textSecondary" variant="body1">
        Redirecionando... Se não abrir sozinho, <Link href={url}>clique aqui</Link>.
      </Typography>
    </Box>
  )
}

RedirectNovoSistema.propTypes = {
  to: PropTypes.string.isRequired
}

export default RedirectNovoSistema
